import { Component, Prop, h, Element } from '@stencil/core';
import { format } from '../../utils/utils';
import ImgPreviewer from "../../utils/img-previewer/index"

@Component({
  tag: 'my-component',
  styleUrl: 'my-component.css',
  shadow: true,
})
export class MyComponent {
  @Element() element: HTMLElement;
  /**
   * The first name
   */
  @Prop() first: string;

  /**
   * The middle name
   */
  @Prop() middle: string;

  /**
   * The last name
   */
  @Prop() last: string;

  private getText(): string {
    console.log(this)
    return format(this.first, this.middle, this.last);
  }

  async componentDidLoad(): Promise<void> {
    console.log(this.element.shadowRoot)
    new ImgPreviewer('#app2', {
      fillRatio: 0.7,
      imageZoom: {
        step: 1
      },
      i18n: {
        RESET: 'reset',
        ROTATE_LEFT: 'rotate left',
        ROTATE_RIGHT: 'rotate right',
        CLOSE: 'close',
        NEXT: 'next',
        PREV: 'prev'
      },
      style: {
        modalOpacity: 0.8
      },
      bubblingLevel: 1,
      root: this.element.shadowRoot
    } as any)


    new ImgPreviewer('#app3', {
      fillRatio: 0.7,
      imageZoom: {
        step: 1
      },
      i18n: {
        RESET: 'reset',
        ROTATE_LEFT: 'rotate left',
        ROTATE_RIGHT: 'rotate right',
        CLOSE: 'close',
        NEXT: 'next',
        PREV: 'prev'
      },
      style: {
        modalOpacity: 0.8
      },
      bubblingLevel: 1,
      root: this.element.shadowRoot
    } as any)
  }

  render() {
    return <div>
      Hello, World! I'm {this.getText()}
      <div>
        <div id="app2">
          <img src="https://www.jackery.com/cdn/shop/files/Solar_Generator_3000_Pro_Featured_Products_1920x.png?v=1685352114" alt="" />
          <img src="https://www.jackery.com/cdn/shop/files/E2000Pro_200Wx2_1920x.png?v=1689241607" alt="" />
          <img src="https://www.jackery.com/cdn/shop/files/3000pro_962_x_940_1920x.png?v=1685418234" alt="" />
        </div>

        <div id="app3">
          <img src="https://www.jackery.com/cdn/shop/files/E2000Pro_200Wx2_1920x.png?v=1689241607" alt="" />
          <img src="https://www.jackery.com/cdn/shop/files/3000pro_962_x_940_1920x.png?v=1685418234" alt="" />
        </div>
      </div>
    </div>;
  }
}
